<template>
  <div>
    <div
      ref="popup"
      class="desc-popup"
      :class="{ show: showPopup }"
      :style="{ ...popupLocation }"
    >
      <div v-for="a in popupInfo" :key="a">
        {{ a }}
      </div>
    </div>
    <Dialog
      class="get-prize"
      width="90%"
      title="领取返利"
      @close="isOpen = false"
      show-close
      :open="isOpen"
    >
      <div class="area">
        <div class="text">
          截止目前您的充值总额为：<span class="h"
            >{{ this.payData?.person_money || 0 }}元</span
          >
        </div>
        <div class="text">
          您本次活动最高可领取礼包：<span class="h">{{
            maxPersonGift?.gift_name || "无"
          }}</span>
        </div>
        <div class="prize-process">
          <div
            class="item-wrapper"
            v-for="(p, i) in prizeInfo.person_gift"
            :key="p.reward_id"
          >
            <div
              v-if="i > 0"
              class="divider"
              :class="{ active: p.status !== 0 }"
            ></div>
            <div
              @click="onGiftClick($event, 'person', p)"
              class="item"
              :class="{
                blink: currentPersonGift?.reward_id === p.reward_id,
              }"
            >
              <img
                class="got-tag"
                src="../../../assets/got.png"
                v-if="p.status === 1"
              />
              <img class="icon" :src="p.icon" />
              {{ p.gift_name }}
            </div>
          </div>
        </div>
        <div class="actions">
          <div
            class="gift-code"
            v-show="
              currentPersonGift?.is_current_game &&
              currentPersonGift?.status === 1 &&
              currentPersonGift?.gift_type === 0
            "
          >
            <div class="code person-code">
              {{ currentPersonGift?.gift_code }}
            </div>
            <Button
              width="9rem"
              height="2.5rem"
              @click="copyGiftCode(currentPersonGift)"
              >复制礼包码</Button
            >
          </div>
          <Button
            v-show="
              !(
                currentPersonGift?.is_current_game &&
                currentPersonGift?.status === 1 &&
                currentPersonGift?.gift_type === 0
              )
            "
            class="btn-get"
            :class="{
              disabled: !currentPersonGift || currentPersonGift.status !== 2,
            }"
            width="15rem"
            height="2.5rem"
            @click="openConfirm('person')"
            >领取奖励</Button
          >
        </div>
      </div>
      <div class="area">
        <div class="text">
          截止目前您的队伍充值总额为：<span class="h"
            >{{ this.payData?.team_money || 0 }}元</span
          >
        </div>
        <div class="text">
          您本次活动最高可领取礼包：<span class="h">{{
            maxTeamGift?.gift_name || "无"
          }}</span>
        </div>
        <div class="prize-process">
          <div
            class="item-wrapper"
            v-for="(p, i) in prizeInfo.team_gift"
            :key="p.reward_id"
          >
            <div
              v-if="i > 0"
              class="divider"
              :class="{ active: p.status !== 0 }"
            ></div>
            <div
              @click="onGiftClick($event, 'team', p)"
              class="item"
              :class="{
                blink: currentTeamGift?.reward_id === p.reward_id,
              }"
            >
              <img
                class="got-tag"
                src="../../../assets/got.png"
                v-if="p.status === 1"
              />
              <img class="icon" :src="p.icon" />
              {{ p.gift_name }}
            </div>
          </div>
        </div>
        <div class="actions">
          <div
            class="gift-code"
            v-show="
              currentTeamGift?.is_current_game &&
              currentTeamGift?.status === 1 &&
              currentTeamGift?.gift_type === 0
            "
          >
            <div class="code person-code">
              {{ currentTeamGift?.gift_code }}
            </div>
            <Button
              width="9rem"
              height="2.5rem"
              @click="copyGiftCode(currentTeamGift)"
              >复制礼包码</Button
            >
          </div>
          <Button
            v-show="
              !(
                currentTeamGift?.is_current_game &&
                currentTeamGift?.status === 1 &&
                currentTeamGift?.gift_type === 0
              )
            "
            class="btn-get"
            :class="{
              disabled: !currentTeamGift || currentTeamGift?.status !== 2,
            }"
            width="15rem"
            height="2.5rem"
            @click="openConfirm('team')"
            >领取奖励</Button
          >
        </div>
      </div>
    </Dialog>
    <Dialog
      @close="showConfirm = false"
      class="confirm"
      :open="showConfirm"
      show-close
      title="奖励领取"
      width="70%"
      close-on-click-modal
    >
      <div class="info">
        <div>
          本次奖励<span class="h">【{{ currentGift?.gift_name }}】</span>
        </div>
        <div v-show="this.currentGift?.gift_type === 1">将发放至角色</div>
        <div v-show="this.currentGift?.gift_type === 1" class="h">
          {{ this.roleInfo?.server_name }}-{{ this.roleInfo?.role_name }}
        </div>
        <div v-show="this.currentGift?.gift_type === 1" class="tip">
          注:可在活动页换绑角色，奖励一经发放无法退回
        </div>
      </div>
      <div class="btns">
        <Button @click="handleGet" class="confirm" width="8rem">确认</Button>
        <Button @click="showConfirm = false" class="cancel" width="8rem"
          >取消</Button
        >
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/dialog/index.vue";
import Button from "@/components/button/index.vue";
export default {
  components: {
    Dialog,
    Button,
  },
  data() {
    return {
      popupLocation: {
        top: 0,
        left: 0,
      },
      showPopup: false,
      popupInfo: [],
      roleInfo: {},
      groupInfo: {},
      prizeInfo: {},
      isOpen: false,
      app_type: null,
      payData: null,
      currentPersonGift: null,
      currentTeamGift: null,
      showConfirm: false,
      scene: null,
      currentPopupGift: null,
      gameInfo: null,
    };
  },
  computed: {
    currentGift() {
      return this.scene === "person"
        ? this.currentPersonGift
        : this.currentTeamGift;
    },
    maxPersonGift() {
      let g;
      if (this.prizeInfo.person_gift)
        (this.prizeInfo.person_gift || []).forEach((item) => {
          if (item.status !== 0) {
            g = item;
          }
        });
      return g;
    },
    maxTeamGift() {
      let g = null;
      if (this.prizeInfo.team_gift)
        (this.prizeInfo.team_gift || []).forEach((item) => {
          if (item.status !== 0) {
            g = item;
          }
        });
      return g;
    },
  },
  methods: {
    onGiftClick(e, scene, gift) {
      if (gift !== this.currentPopupGift) {
        this.currentPopupGift = gift;
        this.popupInfo = gift.goods_list.map((goods) => {
          return goods.name + "*" + goods.goods_count;
        });
        this.$nextTick(() => {
          const height = this.$refs.popup.clientHeight;
          const width = this.$refs.popup.clientWidth;
          const sw = window.innerWidth;
          const sh = window.innerHeight;

          let x = e.x;
          let y = e.y;

          if (x + width > sw) {
            x = sw - 1.5 * width;
          }
          if (y + height > sh) {
            y = sh - 1.5 * height;
          }

          this.popupLocation = {
            top: y + "px",
            left: x + "px",
          };
          this.showPopup = true;
          const listener = () => {
            this.currentPopupGift = null;
            this.showPopup = false;
            window.removeEventListener("pointerdown", listener);
          };
          window.addEventListener("pointerdown", listener, { passive: true });
        });
      }
      if (scene === "person") {
        this.currentPersonGift = gift;
      } else {
        this.currentTeamGift = gift;
      }
    },
    openConfirm(scene) {
      this.scene = scene;

      if (!this.currentGift) {
        this.$toast("请选择礼包");
        return;
      }

      if (this.currentGift.gift_type === 1 && !this.roleInfo?.role_id) {
        this.$toast("未绑定角色，请绑定后领取");
        return;
      }
      this.showConfirm = true;
    },
    // 查看充值数据接口
    loadPayData() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type: this.app_type,
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.payData,
        params: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.payData = res.data.data;
        }
      });
    },
    load({ papp_id, app_type }) {
      this.app_type = app_type;
      let data = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        papp_id,
        app_type,
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.getGiftList,
        params: data,
      }).then((res) => {
        this.prizeInfo = res.data.data;
        let c1, c2;
        (this.prizeInfo.person_gift || []).forEach((item) => {
          if (item.status === 2) c1 = item;
        });
        (this.prizeInfo.team_gift || []).forEach((item) => {
          if (item.status === 2) c2 = item;
        });
        if (!this.currentPersonGift) this.currentPersonGift = c1;
        if (!this.currentTeamGift) this.currentTeamGift = c2;
      });
    },
    /**
     * 复制礼包码
     */
    copyGiftCode(gift) {
      if (!gift?.gift_code) {
        this.$toast("暂无可用的礼包码");
        return;
      }

      const input = document.createElement("input");
      input.value = gift.gift_code;
      document.body.appendChild(input);
      input.select();

      try {
        document.execCommand("copy");
        this.$toast("复制成功");
      } catch (err) {
        this.$toast("复制失败，请手动复制");
        console.error("复制失败:", err);
      } finally {
        document.body.removeChild(input);
      }
    },
    /**
     * 领取礼包接口
     */
    handleGet() {
      let data = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type: this.app_type,
        scene: this.scene,
        gift_id: this.currentGift.gift_id,
        reward_id: this.currentGift.reward_id,
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.getGift,
        params: data,
      }).then((res) => {
        if (res.data.code === 200) {
          this.currentGift.status = 1;
          if (this.currentGift.gift_type === 0)
            this.currentGift.gift_code = res.data.data.gift_code;
          this.showConfirm = false;
          this.$toast(res.data.msg);
          this.load(this.gameInfo).catch((err) => {
            console.log(err);
          });
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    open(game, role, groupInfo, prizeInfo) {
      this.roleInfo = role;
      this.groupInfo = groupInfo;
      this.prizeInfo = prizeInfo;
      this.gameInfo = game;
      this.isOpen = true;
      this.load(game).catch((err) => {
        console.log(err);
      });
      this.loadPayData().catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.desc-popup {
  pointer-events: none;
  padding: 0.5rem 1rem;
  border-radius: 0.2rem;
  text-align: left;
  z-index: 5;
  top: 0;
  background: rgba($color: #000000, $alpha: 0.6);
  position: fixed;
  color: white;
  opacity: 0;
  &.show {
    opacity: 1;
  }
}
.get-prize {
  position: fixed;
  :deep(.outer) {
    .dialog {
      overflow: hidden;
      max-height: 95vh;
      .body {
        max-height: calc(95vh - 4rem);
        overflow: auto;
      }
    }
  }
  .area {
    padding: 1rem 1.5rem 2rem 1.5rem;
    &:not(:last-child) {
      border-bottom: 0.01rem solid #f5f5f5;
    }
    .prize-process {
      overflow-x: auto;
      overflow-y: hidden;
      justify-content: flex-start;
      align-items: center;
      display: flex;
      margin-top: 1rem;
      padding: 0.1rem;
      padding-bottom: 2.5rem;
      min-height: 9rem;
      box-sizing: border-box;
      .item-wrapper {
        display: flex;
        align-items: center;
      }
      .item {
        &.disabled {
          pointer-events: none;
        }
        &:has(.got-tag) {
          .icon {
            filter: grayscale(100%);
            box-shadow: none !important;
            border: none !important;
          }
        }
        cursor: pointer;
        text-align: center;
        width: 4.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        height: 4.5rem;
        flex-direction: column;
        color: gray;
        font-size: 0.8rem;
        position: relative;
        img {
          padding: 0.25rem;
          width: 4rem;
          height: 4rem;
          border-radius: 0.2rem;
          background: #ededed;
          border: 0.1rem solid #ddd;
        }
        .got-tag {
          background: rgba($color: #ededed, $alpha: 0.8);
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 2;
        }

        &.blink {
          img {
            border: 0.1rem solid #ed4b43;
            box-shadow: 0 0 0.2rem #ed4b43;
          }
        }
      }
      .divider {
        width: 3rem;
        height: 0.3rem;
        border-top: 0.1rem solid #ddd;
        background: #ededed;
        border-bottom: 0.1rem solid #ddd;
        &.active {
          background: rgb(255, 87, 80);
        }
      }
    }
  }
  .text {
    color: gray;
    margin-top: 1rem;
    .h {
      color: rgb(250, 56, 46);
    }
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    .gift-code {
      box-sizing: border-box;
      width: 18rem;
      height: 2.5rem;
      background: rgb(242, 242, 242);
      display: flex;
      justify-content: space-between;
      border: 0.1rem solid #ddd;
      border-radius: 2.5rem;
      align-items: center;
      .code {
        width: 7rem;
        overflow: hidden;
        text-overflow: ellipsis;
        color: gray;
        margin-left: 1rem;
      }
    }
    .btn-get {
      background: url(../../../assets/get-gift-btn.png) no-repeat center;
      background-size: contain;
      &.disabled {
        pointer-events: none;
        background: #c3c3c3;
        background-size: contain;
      }
    }
  }
  :deep(.outer .dialog) {
    border-radius: 0.5rem;
    padding: 0;
  }
  :deep(.outer .dialog .header .dialog-close) {
    top: 1.3rem;
    right: 1.2rem;
    width: 1.2rem;
    height: 1.2rem;
  }
}
.confirm {
  :deep(.outer) {
    .dialog {
      .header {
        height: 3rem;
        .dialog-close {
          top: -0.1rem;
          width: 0.9rem;
        }
      }
      .body {
        padding: 0.5rem 0 1rem 0;
      }
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.05rem;
    .h {
      color: rgb(250, 56, 46);
    }
    .tip {
      font-weight: lighter;
      color: rgb(143, 143, 143);
      font-size: 0.8rem;
    }
  }
  .btns {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    gap: 1rem;
    .cancel {
      background: rgb(195, 195, 195);
    }
  }
}
</style>
